import angular from 'angular';

import onboardingChecklistService from '@client/src/global/services/onboarding-checklist';
import { ShipmentTrackingCellComponent } from './shipment-tracking-cell.component';

angular
  .module('app.global.shipment-cells.tracking', [onboardingChecklistService])
  .component('shipmentTrackingCell', ShipmentTrackingCellComponent);
